<!-- TODO: definire il testo -->
<app-toolkit-page-title title="Privacy"></app-toolkit-page-title>
<div class="row">
    <div class="col-sm-12">
        Il presente documento ha lo scopo di informarLa circa la liceità e le finalità del trattamento dei dati personali da Lei forniti e che le operazioni di trattamento avverranno nel pieno rispetto dei principi di correttezza e trasparenza nonché di tutela della Sua riservatezza e dei Suoi diritti. 
        Pertanto, in armonia con quanto previsto dal Regolamento Europeo 2016/679 (di seguito “Regolamento”), dal D.lgs. 30 giugno 2003, n. 196 così come modificato dal D.lgs. 10 agosto 2018, n. 101 (di seguito il “Codice Privacy”), Le forniamo le seguenti, precise e chiare informazioni sul trattamento dei dati personali, secondo le prescrizioni di cui all’art. 13 del Regolamento. 
        <br>
        <br>
        <strong> 1.	Il Titolare del trattamento.</strong>
        <br>
        <br>

        Il Titolare del trattamento è l'ente pubblico Regione Lombardia (C.F. 80050050154, P. IVA 12874720159), con sede in Piazza Città di Lombardia,1 - 20124 Milano.
        <br>
        <br>
        <strong>
            2.	Finalità e base giuridica del trattamento.
        </strong>
        
        <br>
        <br>
        La informiamo che durante le operazioni di trattamento saranno raccolte le seguenti categorie di dati personali, per le finalità e secondo le basi giuridiche di seguito indicate:
        
        <br>
        <br>
        
        <table>
            <tr>
              <th>Finalità</th>
              <th>Base giuridica</th>
              <th>Categorie di dati personali</th>
            </tr>
            <tr>
              <td>I Suoi dati personali sono trattati al fine di contribuire al Catasto regionale delle Opere di Difesa del Suolo in qualità di dipendente della Pubblica Amministrazione per l’adempimento dei Suoi doveri. I dati personali (quali dati anagrafici, dati di contatto) sono trattati al fine di gestire l’accesso al portale e di registrare i nominativi di chi interviene nella gestione informativa delle Opere presenti.
                <br>
                <br>
                Regione Lombardia promuove e partecipa ad attività finalizzate a migliorare la conoscenza del territorio, con lo scopo di prevenire i rischi naturali e di incrementare la qualità e l'efficacia delle azioni di difesa del suolo.	
            </td>
              <td>Base giuridica del trattamento è “l'esecuzione di un compito di interesse pubblico o connesso all'esercizio di pubblici poteri di cui è investito il titolare del trattamento” ai sensi dell’art. 6, par. 1, lett. e) del Regolamento Europeo 2016/679 e art. 2-ter del D.lgs. 193/03 (Codice della Privacy).
                <br>
                <br>
                Queste attività sono previste sia dall’art. 6 della legge sulla difesa del suolo (l.r. n. 4 del 2016) sia dall’art. 55 della legge per il governo del territorio (l.r. n. 12 del 2005).	
            </td>
              <td>Dati comuni: Codice fiscale, Cognome, Nome, Indirizzo e-mail, Numero Cellulare.
            </td>
            </tr>
          </table>
         	
        <br>
        <br>
        <strong>
            3.	Processo decisionale interamente automatizzato, compresa la profilazione.
        </strong>
        <br>
        <br>
        I Suoi dati personali non saranno oggetto di alcun processo decisionale interamente automatizzato, ivi compresa la profilazione.
        <br>
        <br>
        
        <strong>

            4.	Obbligo del conferimento di dati personali. Conseguenze in caso di un eventuale rifiuto.
        </strong>
        
        <br>
        <br>
        Il conferimento dei Suoi dati personali, è necessario e pertanto l'eventuale rifiuto a fornirli in tutto o in parte può dar luogo all'impossibilità per il Titolare di svolgere correttamente tutti gli adempimenti, tra cui l'esecuzione di un compito di interesse pubblico o l'esercizio di pubblici poteri di cui è investito.
        <br>
        <br>
        <strong>

            5.	Comunicazione e diffusione a terzi di dati personali.
        </strong>
        
        <br>
        <br>
        I destinatari dei Suoi dati personali sono stati adeguatamente istruiti per poter trattare i Suoi dati personali, e assicurano il medesimo livello di sicurezza offerto dal Titolare.
        
        Inoltre, i Suoi dati personali, vengono comunicati a soggetti terzi (es. fornitori), in qualità di Responsabili del trattamento, appositamente nominati, che forniscono al Titolare del trattamento prestazioni o servizi strumentali alle finalità indicate nella presente informativa. 
        
        Il Titolare del trattamento ha nominato, ARIA S.p.A., Azienda Regionale per l’innovazione e gli Acquisti della Regione Lombardia come Responsabile del trattamento.

        <br>
        <br>
        
        <strong>

            6.	Trasferimenti di dati personali al di fuori dello Spazio Economico Europeo. 
        </strong>
        
        <br>
        <br>

        I Suoi dati personali non verranno trasferiti al di fuori dello Spazio Economico Europeo.
        <br>
        <br>

        <strong>

            7.	Tempi di conservazione. 
        </strong>
        <br>
        <br>
        I Suoi dati personali saranno conservati fintantochè sarà registrato al portale o comunque fino alla cessazione del Suo ruolo nell’Ente per il quale Lei si è registrato. 

        <br>
        <br>
        <strong>

            8.	I diritti degli interessati.
        </strong>
        <br>
        <br>
        Lei potrà esercitare, in ogni momento, ove applicabili, i diritti di cui agli artt. da 15 a 22 del Regolamento UE 679/2016, attraverso una richiesta da inoltrare all'attenzione del Titolare del trattamento.
        Tuttavia, Le specifichiamo che, in base a determinate misure legislative introdotte dal diritto nazionale, il Titolare del trattamento, in alcune circostanze, potrà limitare la portata degli obblighi e dei diritti, così come precisato dall’art. 23 del Regolamento e dall’art. 2-undecies del Codice Privacy.
        Di seguito i diritti riconosciuti:
        <br>
        <br>
        •	Diritto di accesso (art. 15)
        <br>
        <br>
        •	Diritto alla rettifica (art. 16)
        <br>
        <br>
        •	Diritto alla cancellazione (art. 17)
        <br>
        <br>
        •	Diritto alla limitazione del trattamento (art. 18)
        <br>
        <br>
        •	Diritto di opposizione (artt. 21 e 22)
        <br>
        <br>
        
        Il Titolare del trattamento potrà essere contattato al seguente indirizzo: <strong>territorio_sistemiverdi@pec.regione.lombardia.it</strong>, oppure, a mezzo posta raccomandata all'indirizzo Piazza Città di Lombardia 1, 20124 Milano (MI), Italia, all'attenzione della Direzione Generale Territorio e Sistemi Verdi.
        
        <br>
        <br>
        <strong>

            9.	Reclamo all’Autorità di controllo.  
        </strong>
        
        <br>
        <br>
        Qualora ritenga che il trattamento dei Suoi dati personali avvenga in violazione di quanto previsto dalla normativa vigente, Lei ha il diritto di proporre reclamo al Garante (www.garanteprivacy.it), come previsto dall'art. 77 del Regolamento, o di adire le opportune sedi giudiziarie ai sensi art. 79 del Regolamento.
        
        <br>
        <br>

        <strong>

            10.	Il Responsabile della Protezione dei Dati.
        </strong>
        
        <br>
        <br>
        Il Titolare del trattamento ha nominato un Responsabile della Protezione dei dati (RPD) che potrà essere contattato al seguente indirizzo e-mail: <strong>rpd@regione.lombardia.it</strong>.
        
        <br>
        <br>

        <strong>

            11.	Modifiche.
        </strong>
        <br>
        <br>
        Il Titolare si riserva di aggiornare la presente informativa, anche in vista di future modifiche della normativa in materia di protezione dei dati personali.
        <br>
        <br>
    </div>
</div>